export { default } from './Chip';


// WEBPACK FOOTER //
// ./node_modules/@material-ui/core/es/Chip/index.js